/*
 * CLAIM-INFO-CARD.JSX - Claim Information Card Component for Invoice Summary
 * 
 * SUMMARY:
 * A reusable card component that displays financial claim information in a standardized format.
 * Used in the invoices list to show key financial metrics like Total Amount Claimed, 
 * Total Retention, and Amount Approved.
 */

import React from 'react'

const ClaimInfoCard = ({ title, amount, customStyleClass = '', ...props }) => {
  return (
    <div className={`summary-card ${customStyleClass}`} {...props}>
      <div className="card-content">
        <h3>{title}</h3>
        <p className="amount">{amount}</p>
      </div>
    </div>
  )
}

export default ClaimInfoCard